import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import NotificationsIcon from "@material-ui/icons/NotificationsOutlined";
import MoreIcon from "@material-ui/icons/MoreVert";
import { auth, db } from "../settings/firebase";
import AuthCheck from "../components/Authentication/Check";
import getQueryStrings from "../utils/getQueryStrings";
import Search from "./Searchbox";
import MediaQuery from "react-responsive";

// CSSスタイル
const barStyle = makeStyles(() => ({
  AppHeader: {
    position: "static",
    // width: "calc(100vw - 17px)",
    height: "64px",
    display: "flex",
    /* main_color */
    //background: "rgba(254, 253, 248, 0.94)"
  },
  AppToolbar: {
    height: "100%",
    alignItems: "center",
    paddig: "0px",
  },
  /* SelectBook */
  Apptitle: {
    height: "64px",
    minWidth: "5.5em",
    alignItems: "center",
    // フォント
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "900",
    fontSize: "32px",
    lineHeight: "216%",
    /* identical to box height, or 64px */
    color: "#35322C"
  },
  barGrow: {
    flexGrow: "1"
  },
  barSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  /* barIcon */
  barIcon: {
    width: "44px",
    height: "44px",
    marginRight: "7px",
  },
  /* Icon */
  iconCircle: {
    width: "32px",
    height: "32px",
    color: "#555046",
  },
}));

// 現在のパスをパラメタにセットする
function nowlocation() {
  const redirect = getQueryStrings(window.location.search)["redirect"];
  if (redirect && redirect !== "/") {
    return "?redirect=" + encodeURIComponent(redirect);
  } else if (["/", "/signin", "/signup", "/signout"].indexOf(window.location.pathname) === -1) {
    return "?redirect=" + encodeURIComponent(window.location.pathname);
  }
  return "";
}

class Notificatonbadge extends React.Component {
  constructor(props){
    super(props);
    this.state = {notif: 0, notifidata: []}
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }

  _isMounted = false;
  // 新着通知の数を取得する
  componentDidMount() {
    const user = auth.currentUser;
    if (user !== null) {
      let notifDocRef = db.collection("messages").doc(user.uid).collection("notifications");
      // 新着通知のみを取得する
      notifDocRef.where("read", "==", false).get().then(docs => {
        let notifications = [];
        docs.forEach(doc => {
          const item = doc.data();
          notifications.unshift(item);
        })
        this.setState({notif: notifications.length, notifdata: notifications});
        this._isMounted = true;
      }).catch(error => {
        return;
      })
    };
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <Badge badgeContent={this.state.notif} color="primary">
        {this.props.children}
      </Badge>
    )
  }
}

export default function Header() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isMounted, setisMounted] = React.useState(false);
  const [notifiCount, setnotifiCount] = React.useState(0);
  const isMenuOpen = Boolean(anchorEl);

  const handleOptionMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOptionMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDisplayUserPage = async () => {
    const user = auth.currentUser;
    setAnchorEl(null);
    if (user !== null) {
      db.collection("users").doc(user.uid).get().then(doc => {
        window.location.href = "/" + doc.data().displayid;
      }).catch(error => {
        return;
      })
    } else {
      return;
    }
  };

  const handleNotifications = () => {
    window.location.href = "/notification?redirect=" + encodeURIComponent(window.location.pathname);
  }

  const renderOptionMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id="accountMenu"
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      disableScrollLock={ true }
      open={isMenuOpen}
      onClose={handleOptionMenuClose}
    >
      <MediaQuery query="(max-width: 500px)">
        <MenuItem component="a" href={"/notification?redirect=" + encodeURIComponent(window.location.pathname)} onClick={handleOptionMenuClose}>
          <Badge badgeContent={notifiCount} color="primary">
            <NotificationsIcon />通知&ensp;
          </Badge>
        </MenuItem>
      </MediaQuery>
      <MenuItem onClick={handleDisplayUserPage}>プロフィール</MenuItem>
      <MenuItem component="a" href="/settings" onClick={handleOptionMenuClose}>アカウント設定</MenuItem>
      <MenuItem component="a" href="/?intro=1" onClick={handleOptionMenuClose}>チュートリアルを見る</MenuItem>
      <MenuItem component="a" href={"/signout" + nowlocation()} onClick={handleOptionMenuClose}>ログアウト</MenuItem>
    </Menu>
  );

  const classes = barStyle();
  return (
    <>
      <AppBar className={classes.AppHeader} color="secondary">
        <Toolbar className={classes.AppToolbar}>
          <Button className={classes.Apptitle} href="/">
            <Typography className={classes.Apptitle} variant="h1" noWrap>SelectBook</Typography>
          </Button>
          <div className={classes.barGrow} />
          <AuthCheck>
            <div className={classes.barSection}>
              <Search className={classes.iconCircle} />
              <MediaQuery query="(min-width: 501px)">
                <IconButton
                  className={classes.barIcon}
                  aria-label="show new notifications"
                  onClick={handleNotifications}
                >
                  <Notificatonbadge>
                    <NotificationsIcon className={classes.iconCircle} />
                  </Notificatonbadge>
                </IconButton>
              </MediaQuery>
              <IconButton
                edge="end"
                className={classes.barIcon}
                aria-label="option of current user"
                aria-haspopup="true"
                onClick={handleOptionMenuOpen}
              >
                <MoreIcon className={classes.iconCircle} />
              </IconButton>
              {renderOptionMenu}
            </div>
          </AuthCheck>
          <AuthCheck signout>
            <div className={classes.barSection}>
              <Search iconSize="32px" color="#555046" />
            </div>
          </AuthCheck>
        </Toolbar>
      </AppBar>
    </>
  );
}
